import { GetServerSideProps } from "next";
import Head from "next/head";
import config from "../../../config";
import { EcommerceEventList } from "../../../models/Event";
import { Container } from "@mui/material";
import { setupStyleMapFromStyleMap } from "../../../utils/helpers";
import React from "react";
import PageWrapper from "../../../components/PageWrapper";
import Cart from "../../../components/cart/Cart";
import { useCartStore } from "../../../stores/CartStore";
import dynamic from "next/dynamic";
import { COOKIE_BOXOFFICE_KEY } from "../../../stores/AuthStore";
import { tokenIsValid } from "../../../utils/jwtHelpers";
import { useRouter } from "next/router";

const EventList = dynamic(
    () => import("../../../components/event-list/EventList"),
    { ssr: false },
);

export default function Home(props: {
    eventList: EcommerceEventList;
    style: EcommerceEventList;
}) {
    useCartStore(props.eventList.cartUrl);

    React.useEffect(() => {
        if (props.eventList.newStyleMap) {
            setupStyleMapFromStyleMap(props.eventList.newStyleMap);
        }
    }, []);

    const pageTitle = `Buy tickets for ${props.eventList.clientName} events.`;

    return (
        <>
            <Head>
                <title>{pageTitle}</title>
                <meta
                    name="description"
                    content={`Buy tickets for ${props.eventList.clientName} events.`}
                />
            </Head>
            <PageWrapper eventList={props.style}>
                <Container maxWidth="md">
                    <EventList eventList={props.eventList} />
                </Container>
            </PageWrapper>
            <Cart />
        </>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const cartUrl = context.params?.cartUrl;
    let data: any,
        style: any,
        error = false;

    const boxoffice = context.req.cookies[COOKIE_BOXOFFICE_KEY];
    let salesContext = "ECOMMERCE";

    if (
        boxoffice == "true" &&
        tokenIsValid(
            context.req.cookies[
                config.COOKIE_PREFIX + "__authentigate_token_sanitized"
            ],
        )
    ) {
        salesContext = "BOXOFFICE";
    }

    const start = Date.now();
    try {
        const res = await fetch(
            `${config.BACKEND_URI}/sales/ecommerce-events/${cartUrl}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Sales-Context": salesContext,
                    Cookie: context.req.headers.cookie ?? "",
                },
                credentials: "include",
            },
        );
        if (res.status !== 200) {
            error = true;
            console.log(await res.text());
        } else {
            data = await res.json();
        }
    } catch (err) {
        console.log(err);
        error = true;
    }

    try {
        const res = await fetch(
            `${config.BACKEND_URI}/sales/cart-style/${cartUrl}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Sales-Context": "ECOMMERCE",
                },
            },
        );
        if (res.status !== 200) {
            error = true;
            console.log(await res.text());
        } else {
            style = await res.json();
        }
    } catch (err) {
        console.log(err);
        error = true;
    }

    const end = Date.now();
    console.log(`Time to fetch data: ${end - start}ms`);

    if (data?.newStyleMap) {
        setupStyleMapFromStyleMap(data.newStyleMap);
    }

    return {
        props: { eventList: data, style },
        notFound: error,
    };
};
